import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  createDeliverableBillable: (deliverableId, billableId) => {
    return AxiosBusiness.post(`deliverable/${deliverableId}/billable/${billableId}`)
  },

  deleteDeliverableBillable: (deliverableId, billableId) => {
    return AxiosBusiness.delete(`deliverable/${deliverableId}/billable/${billableId}`)
  },

  getDeliverableBillable: (deliverableId, billableId) => {
    return AxiosBusiness.get(`deliverable/${deliverableId}/billable/${billableId}`)
  },
}
